import { ReactNode } from 'react';
import cn from 'classnames';
export interface CardProps {
  children: ReactNode;
  className?: string;
}

export function Card({ children, className }: CardProps) {
  return (
    <div
      className={cn(
        'flex flex-col bg-white rounded-lg shadow divide-y divide-gray-200',
        className,
      )}
    >
      <div className="relative flex-1 flex flex-col p-8">{children}</div>
    </div>
  );
}

export default Card;
